import moment from 'moment-timezone';
import { useTimeZone } from './user-time-zone';

export const useScopedDate = ({
  date: dateInput,
  invalidLabel = '',
}) => {
  const timeZone = useTimeZone();
  const date = dateInput.includes('.000Z') ?  moment.tz(dateInput, 'UTC') : moment.tz(dateInput, timeZone);
  if (!date.isValid()) {
    return invalidLabel;
  }
  const duration = moment.duration(moment().diff(date));
  const hours = duration.as('hours');
  if (hours < 24 ) {
    return date.format('h:mm A');
  }
  const days = duration.as('days')
  
  if (days < 7) {
    return date.format('ddd h:mm A');
  }
  return date.format('MMM D, YYYY, h:mm A');
};
